const companyMessages = {
  'company.title': '企業管理',
  'company.CompanyLists.title.companyCode': '企業コード',
  'company.CompanyLists.title.companyName': '企業名',
  'company.CompanyLists.title.activated': 'アクティベート',
  'company.CompanyLists.title.childrenNumber': '企業数',
  'company.CompanyLists.title.licenseNumber': 'ライセンス数',
  'company.CompanyLists.title.voiceAnalysis': '音声解析',
  'company.CompanyLists.title.voiceAnalysis.autoAnalysisEnabled':
    '自動音声解析',
  'company.CompanyLists.title.ocr': '画像解析',
  'company.CompanyLists.title.remoteSupport': '遠隔支援',
  'company.CompanyLists.title.ocr.autoAnalysisEnabled': '自動画像解析',
  'company.CompanyLists.title.storage': 'ストレージ',
  'company.CompanyLists.title.lat': '緯度',
  'company.CompanyLists.title.lng': '経度',
  'company.CompanyLists.title.address': '住所',
  'company.CompanyLists.title.zipCode': '郵便番号',
  'company.CompanyLists.title.companyType': '企業タイプ',
  'company.CompanyLists.title.storageType.0': 'unknown type',
  'company.CompanyLists.title.storageType.1': '標準',
  'company.CompanyLists.title.storageType.2': '標準＋カスタム',
  'company.CompanyLists.title.storageType.3': 'カスタム',
  'company.CompanyLists.License.title.user': 'ユーザ数',
  'company.CompanyLists.License.title.id': 'ID',
  'company.CompanyLists.title.activated.activated': '済',
  'company.CompanyLists.title.activated.notActivated': '未',
  'company.CompanyTitle.createCompanyButton.name': '企業新規作成',
  'company.CompanyDialog.title.name': '企業新規作成',
  'company.CompanyDialog.title.companyCode': '企業コード',
  'company.CompanyDialog.button.create': '作成',
  'company.CompanyDialog.button.cancel': 'キャンセル',
  'company.CompanyDialog.message.1501': '使用されている企業コードです',
  'company.UpdateCompany.title': '企業情報更新',
  'company.UpdateCompany.title.companyCode': '企業コード',
  'company.UpdateCompany.title.companyName': '企業名',
  'company.UpdateCompany.title.activationCode': 'アクティベーションコード',
  'company.UpdateCompany.title.activate': 'アクティベート',
  'company.UpdateCompany.title.activate.activated': 'アクティベート済',
  'company.UpdateCompany.title.activate.notActivated': 'アクティベート未',
  'company.UpdateCompany.title.latlng': '位置情報',
  'company.UpdateCompany.title.lat': '緯度',
  'company.UpdateCompany.title.lng': '経度',
  'company.UpdateCompany.title.zipCode': '郵便番号',
  'company.UpdateCompany.title.address': '住所',
  'company.UpdateCompany.title.operatorDeviceLimit': 'ユーザーデバイス上限数',
  'company.UpdateCompany.title.operatorDeviceLimit.unit': '台',
  'company.UpdateCompany.title.downloadFileNamePatternId':
    'ダウンロード時のファイル名形式',
  'company.UpdateCompany.option.map': 'MAP',
  'company.UpdateCompany.option.zipCode': '(ハイフン「-」を含まない７桁の数字)',
  'company.UpdateCompany.button.update': '更新',
  'company.UpdateCompany.button.dataDelete': 'データを削除',
  'company.UpdateCompany.button.delete': '企業を削除',
  'company.UpdateCompanyDialog.tab.company': '企業情報管理',
  'company.UpdateCompanyDialog.tab.license': 'ライセンス管理',
  'company.UpdateLicense.header.item': '項目',
  'company.UpdateLicense.header.contract': '契約',
  'company.UpdateLicense.header.status': '利用状況',
  'company.UpdateLicense.title.storageType': 'ストレージ',
  'company.UpdateLicense.title.storageType.0': 'unknown type',
  'company.UpdateLicense.title.storageType.1': '標準',
  'company.UpdateLicense.title.storageType.1.subText': 'ライセンス数 x 1 GiB',
  'company.UpdateLicense.title.storageType.2': '標準＋カスタム',
  'company.UpdateLicense.title.storageType.3': 'カスタム',
  'company.UpdateLicense.title.storageType.customNumber': 'カスタム値',
  'company.UpdateLicense.title.storageType.customNumber.unit': ' GiB',
  'company.UpdateLicense.title.storageType.information': '小数第２位を四捨五入',
  'company.UpdateLicense.title.voiceAnalysis': '音声認識',
  'company.UpdateLicense.title.voiceAnalysis.enable': '有効',
  'company.UpdateLicense.title.voiceAnalysis.contractNumber.unit': ' 時間',
  'company.UpdateLicense.title.voiceAnalysis.information':
    '小数第２位を四捨五入',
  'company.UpdateLicense.title.ocr': '画像文字認識',
  'company.UpdateLicense.title.ocr.enable': '有効',
  'company.UpdateLicense.title.ocr.contractNumber.unit': '枚',
  'company.UpdateLicense.title.displayStorageType': 'ストレージ',
  'company.UpdateLicense.title.displayStorageType.0': 'unknown type',
  'company.UpdateLicense.title.displayStorageType.1':
    '標準　ライセンス数 x 1 GiB',
  'company.UpdateLicense.title.displayStorageType.2': '標準＋カスタム',
  'company.UpdateLicense.title.displayStorageType.3': 'カスタム',
  'company.UpdateLicense.title.displayStorageType.customNumber': 'カスタム値',
  'company.UpdateLicense.title.displayStorageType.customNumber.unit': ' GiB',
  'company.UpdateLicense.title.displayStorageType.information':
    '小数第２位を四捨五入',
  'company.UpdateLicense.title.displayVoiceAnalysis': '音声認識',
  'company.UpdateLicense.title.displayVoiceAnalysis.enable':
    '自動解析を有効にする',
  'company.UpdateLicense.title.displayVoiceAnalysis.contractNumber.unit':
    ' 時間',
  'company.UpdateLicense.title.displayVoiceAnalysis.information':
    '小数第２位を四捨五入',
  'company.UpdateLicense.title.displayOcr': '画像文字認識',
  'company.UpdateLicense.title.displayOcr.enable': '自動解析を有効にする',
  'company.UpdateLicense.title.displayOcr.contractNumber.unit': '枚',
  'company.UpdateLicense.title.remoteSupport': '遠隔作業支援',
  'company.UpdateLicense.title.remoteSupport.enable': '有効',
  'company.UpdateLicense.title.remoteSupport.contractNumber.unit': 'ID',
  'company.UpdateLicense.title.displayRemoteSupport': '遠隔作業支援',
  'company.UpdateLicense.title.displayRemoteSupport.contractNumber.unit': 'ID',
  'company.searchOption.checkbox.title.licenseOver': 'ライセンス超過企業',
  'company.searchOption.select.companyType.default':
    '企業タイプで絞り込み(デフォルト:全て)',
  'company.searchOption.input.companyCode.placeholder': '企業コードで絞り込み',
  'company.searchOption.input.companyName.placeholder': '企業名で絞り込み',
  'company.searchOption.title.companyCode': '企業コード：',
  'company.searchOption.title.companyName': '　　企業名：',
  'company.select.default': '企業で絞り込み(デフォルト:全企業)',
  'setCompany.title': '企業選択',
  'setCompany.list.item.companyName': '企業名',
};

export default companyMessages;
